"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.number.max-safe-integer");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getIndianaRulesList;

var _lodash = _interopRequireDefault(require("lodash"));

var _Asset = _interopRequireDefault(require("../Asset"));

var _IDCounter = _interopRequireDefault(require("../../utils/IDCounter"));

var _Rule = require("../Rule");

var _typesMap = _interopRequireDefault(require("../../assets/typesMap"));

var _subTypes = require("../../assets/subTypes");

var _tertiaryTypes = require("../../assets/tertiaryTypes");

var _commonRules = require("./commonRules");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

var stateCode = 'IN';

function getIndianaRulesList(idCounter) {
  return [(0, _commonRules.taxExemptRetirementAccounts)(idCounter, stateCode), {
    id: idCounter.increment(),
    description: 'Military Equipment',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 10-16-10-3',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.MILITARY_EQUIPMENT;
    }
  }, {
    id: idCounter.increment(),
    description: "Workers' Compensation",
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 22-3-2-17',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.WORKERS_COMP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unemployment Compensation',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 22-4-33-3',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.UNEMPLOYMENT_COMPENSATION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Partnerships',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 23-4-1-25',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.PARTNERSHIP;
    }
  }, {
    id: idCounter.increment(),
    description: 'Unpaid Wages -75% or 30 times the federal hourly minimum wage',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 24-4.5-5-105',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.UNPAID_WAGES;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life insurance (spouse)',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-1-12-14',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PAYMENTS_FOR_DEPENDEE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Employer\'s life insurance',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-1-12-17.1(f)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _tertiaryTypes.LIFE_INSURANCE_EMPLOYER;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (group)',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-1-12-29',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.GROUP_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Fraternal benefit',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-11-6-3',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.FRATERNAL_BENEFIT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Life Insurance (if clause prohibits)',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-1-12-14',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.LIFE_INSURANCE_PLAN;
    }
  }, {
    id: idCounter.increment(),
    description: 'Mutual Life and Accident',
    requiresReview: true,
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 27-8-3-23',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.ACCIDENT_INSURANCE;
    }
  }, {
    id: idCounter.increment(),
    description: 'Spendthrift Trusts',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 30-4-3-2',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SPENDTHRIFT_TRUST;
    }
  }, {
    id: idCounter.increment(),
    description: 'Earned Income Tax Credit',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(11)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.INCOME_TAX_CREDIT;
    }
  }, {
    id: idCounter.increment(),
    description: "Veterans' Benefit",
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(12)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.VETERANS_BENEFITS;
    }
  }, {
    id: idCounter.increment(),
    description: 'Supplemental State Fair Relief',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(13)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SUPPLEMENTAL_STATE_FAIR_RELIEF;
    }
  }, {
    id: idCounter.increment(),
    description: 'Cash. ' + 'Deposits of Money. ' + 'Bonds, mutual funds, or publicly traded stocks. ' + 'Non-publicly traded stock and interests in businesses. ' + 'Government and corporate bonds. ' + 'Security deposits and prepayments. ' + 'Annuities. ' + 'Other trusts, equitable or future interests in property and rights or powers exercisable for your benefit. ' + 'Patents, copyrights, trademarks, trade secrets, and other intellectual property. ' + 'Intangible Personal Property. ' + 'Tax refunds owed to you. ' + 'Family support. ' + 'Interests in insurance policies. ' + 'Any interest in property that is due you from someone who has died. ' + 'Claims against third parties, whether or not you have filed a lawsuit or made a demand for payment. ' + 'Other contingent and unliquidated claims of every nature, including counterclaims of the debtor and rights. ' + 'to set off claims". ' + 'Any financial assets you did not already list. ' + 'Accounts receivable or commissions you already earned. ' + 'Customer lists, mailing lists, or other compilations.',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(3)',
    limitAggregateSingle: 400,
    limitAggregateJoint: 800,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      var validSubTypes = [_subTypes.CASH, _subTypes.DEPOSIT, _subTypes.BOND, _subTypes.MUTUAL_FUND, _subTypes.STOCK, _subTypes.BOND, _subTypes.CORPORATE_BOND, _subTypes.ANNUITY, _subTypes.TRUST, _subTypes.PATENT, _subTypes.COPYRIGHT, _subTypes.TRADEMARK, _subTypes.TRADE_SECRET, _subTypes.MISC_INTELLECTUAL_PROPERTY, _subTypes.TAX_REFUND, _subTypes.UNPAID_WAGES].concat(_toConsumableArray(_typesMap["default"][_subTypes.FINANCIAL_ACCOUNTS]), [_subTypes.ACCOUNTS_RECEIVABLE, _subTypes.CUSTOMER_LISTS]);
      return this.canTakeMoreExemptions() && validSubTypes.includes(subType);
    }
  }, {
    id: idCounter.increment(),
    description: 'Health aids',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(4)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTHAID;
    }
  }, {
    id: idCounter.increment(),
    description: 'IRA. Public or Private Retirement Benefits',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(6)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _subTypes.IRA || subType === _subTypes.PENSION_PLAN);
    }
  }, {
    id: idCounter.increment(),
    description: 'Savings Accounts (health)',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(7); Ind. Code Ann. § 34-55-10-2 (c)(8)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HEALTH_SAVINGS_ACCOUNT;
    }
  }, {
    id: idCounter.increment(),
    description: 'Education Savings Accounts',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(9); Ind. Code Ann. § 34-55-10-2 (c)(10)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && (subType === _tertiaryTypes.EDUCATIONAL_IRA || subType === _subTypes.COLLEGE_SAVINGS_ACCOUNT);
    }
  }, {
    id: idCounter.increment(),
    description: 'Tuition Programs',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2(c)(9)',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TUITION_PROGRAM;
    }
  }, {
    id: idCounter.increment(),
    description: 'Real Property of Housing Authority',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 36-7-18-34',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.HOUSING_AUTHORITY_PROPERTY;
    }
  }, {
    id: idCounter.increment(),
    description: "Sheriffs' Pensions",
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 36-8-10-19',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.SHERIFF_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Firefighters Pensions',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 36-8-7-22; Ind. Code Ann. § 36-8-8-17',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.FIREFIGHTERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Police Pensions',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 36-8-8-17; Ind. Code Ann. § 10-12-2-10',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.POLICE_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: 'Public Employees',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 5-10.3-8-9',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      var validTypes = [_tertiaryTypes.PUBLIC_EMPLOYEE_PENSION];
      return this.canTakeMoreExemptions() && validTypes.includes(tertiaryType);
    }
  }, {
    id: idCounter.increment(),
    description: 'State Teachers',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 5-10.4-5-14',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var tertiaryType = _lodash["default"].get(asset, 'assetJSON.tertiaryType');

      return this.canTakeMoreExemptions() && tertiaryType === _tertiaryTypes.TEACHERS_PENSION;
    }
  }, {
    id: idCounter.increment(),
    description: "Crime Victims' Compensation",
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 5-2-6.1-38',
    limitAggregateSingle: Number.MAX_SAFE_INTEGER,
    limitAggregateJoint: Number.MAX_SAFE_INTEGER,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply(asset) {
      var subType = _lodash["default"].get(asset, 'assetJSON.subType');

      return this.canTakeMoreExemptions() && subType === _subTypes.CRIME_VICTIM_COMPENSATION;
    }
  }, {
    id: _Rule.WILDCARD_ID,
    description: 'Wildcard',
    type: stateCode,
    statuteName: 'Ind. Code Ann. § 34-55-10-2 (c)(2)',
    limitAggregateSingle: 10250,
    limitAggregateJoint: 20500,
    limitPerItem: Number.MAX_SAFE_INTEGER,
    assetLimit: Number.MAX_SAFE_INTEGER,
    canApply: function canApply() {
      return this.canTakeMoreExemptions();
    }
  }];
}